// Utilities
export const BASE_URL = "/api";
export const LOGIN = "/login";
export const LOGOUT = "/logout";
export const FORGOT = "/forgot";
export const RESET = "/reset";
export const SEND_EMAIL = "/email";
export const REFRESH = "/refresh";

// USERS
export const USERS = "/users";
export const GET_USER_BY_TOKEN = "/userByToken";
export const DEPARTMENTS = "/departments";
export const CUSTOMERS = "/customers";
export const CONTACTS = "/contacts";
export const ROLES = "/roles";
export const PROJECTS = "/projects";
export const SERVICES = "/services";
export const CODES = "/codes";
export const CHARGETYPES = "/chargetypes";
export const CONTRACTS = "/contracts";
export const EXPENSES = "/expenses";
export const PTOREQUESTS = "/pto-requests";
export const CONTRACT_TIERS = "/contract-tiers";
export const TASKS = "/tasks";
export const DEPARTMENT_CATEGORIES = "/department-categories";
export const MAINTENANCE = "/maintenance";

// Calls
export const CALLS = "/calls";
export const RECURRING_CALLS = "/calls/recurrence";
export const RECURRENCE = "/recurrence";
export const BULK_CALL_APPROVE = "/calls-approve";

// Support Tickets
export const GET_SUPPORT_TICKETS = "/support-tickets";
export const GET_SUPPORT_TICKET = "/support-tickets";
export const PUT_SUPPORT_TICKET = "/support-tickets";

// Invoices
export const GET_INVOICES = "/invoices";
export const GET_INVOICE = "/invoices";
export const POST_INVOICE = "/invoices";
export const PUT_INVOICE = "/invoices";
export const DELETE_INVOICE = "/invoices";
export const BULK_INVOICE_APPROVE = "/invoices-approve";
export const BULK_INVOICE_COMPLETE = "/invoices-complete";

// File Upload
export const POST_FILE = "/upload";

// Email
export const CHECK_CALLS = "/call-count";
export const SEND_GFS_REMINDER = "SEND_GFS_REMINDER";

// Activityu

export const ACTIVITY = "/activity";

export const VERSION = "/version";

// Notifications

export const GET_NOTIFICATIONS = "/notifications";

// REPORTS
export const GET_REPORTS = "/reports";

// APPROVAL
export const GET_APPROVAL = "/approval";

// LOGS
export const LOGS = "/logs";

// Exporting
export const EXPORT = "/export";

// BC Invoice
export const BC_INVOICES = "/bc-invoices";

// Tax Codes
export const TAX_CODES = "/taxcodes";
